import React, { useState, useEffect, useRef } from 'react';
import {
  Modal,
  ModalHeader,
  Table,
  Input, InputGroup,
  InputGroupText,
} from 'reactstrap';
import CustomTableLoader from '../../common/CustomTableLoader';
import { getCurrentAgencyId } from '../../../utils/functions/CustomFunctions';
import { debounce } from 'underscore';
import { useDispatch, useSelector } from 'react-redux';
import { listCustomer } from '../../../redux/actions';

function CustomModalSearch(props) {
  const { toggle, modal = false, selectCallBack } = props;

  const dispatch = useDispatch();
  const [filter, setFilter] = useState({
    customerName: '',
  });

  //Onchange filter
  const changeSearchField = ({ target: { name, value } }) => {
    setFilter({ ...filter, [name]: value });
  };

  //Debounce
  const delayedQuery = useRef(
    debounce(
      (filter) =>
        dispatch(
          listCustomer({
            ...filter,
            agencyId: getCurrentAgencyId(),
          })
        ),
      500
    )
  ).current;

  useEffect(() => {
    delayedQuery(filter);
  }, [filter]);

  const {
    loading = false,
    list = [],
  } = useSelector((state) => state.CustomersReducer);

  return (
    <>
      <Modal centered isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Select a Customer</ModalHeader>
        <div style={{ margin: '10px' }}>
          <InputGroup size="sm">
            
              <InputGroupText>
                <i class="fa fa-search" aria-hidden="true"></i>
              </InputGroupText>
            
            <Input
              type="text"
              name="customerName"
              // placeholder="Customer Name"
              onChange={changeSearchField}
              value={filter.customerName}
              placeholder="select a customer"
            />
          </InputGroup>
        </div>
        <div className="modals-scroll">
          <Table hover>
            {loading && (
              // Table Loader
              <CustomTableLoader columnsCount={1} />
            )}
            <tbody>
              <>
                {list.map((record, key) => (
                  <tr key={key}>
                    <td
                      style={{ cursor: 'pointer' }}
                      data-detail={JSON.stringify(record)}
                      onClick={selectCallBack}
                    >
                      {record.customerName}
                    </td>
                  </tr>
                ))}
              </>
            </tbody>
          </Table>
        </div>
      </Modal>
    </>
  );
}

export default CustomModalSearch;

